import { useState, useEffect } from 'react';
import { registerPanel, closeOtherPanels } from './panelCoordinator';

let listeners = [];
let state = {
  isOpen: false,
  circuitFiles: null,
  circuitTitle: null,
  errors: null,
};

const notify = () => listeners.forEach(l => l({ ...state }));

export const circuitEditor = {
  open: (files, title) => {
    if (state.isOpen && state.circuitFiles === files) return;
    const hadOther = closeOtherPanels('circuit');
    if (state.isOpen || hadOther) {
      state = { isOpen: false, circuitFiles: null, circuitTitle: null };
      notify();
      setTimeout(() => {
        state = { isOpen: true, circuitFiles: files, circuitTitle: title || 'Circuit' };
        notify();
      }, 350);
      return;
    }
    state = { isOpen: true, circuitFiles: files, circuitTitle: title || 'Circuit' };
    notify();
  },

  close: () => {
    state = { isOpen: false, circuitFiles: null, circuitTitle: null, errors: null };
    notify();
  },

  setErrors: (errors) => {
    state = { ...state, errors };
    notify();
  },

  onFixRequest: null,

  getState: () => ({ ...state }),
};

registerPanel('circuit', () => {
  if (!state.isOpen) return false;
  circuitEditor.close();
  return true;
});

export const useCircuitEditor = () => {
  const [editorState, setEditorState] = useState({ ...state });

  useEffect(() => {
    const handler = (s) => setEditorState(s);
    listeners.push(handler);
    return () => {
      listeners = listeners.filter(l => l !== handler);
    };
  }, []);

  return {
    ...editorState,
    open: circuitEditor.open,
    close: circuitEditor.close,
  };
};

export default useCircuitEditor;
